import React from "react";
import Tooltip from "@mui/material/Tooltip";
import CircularProgressChart from "./CircularProgressChart";
import { useMediaQuery } from "@mui/material";
import { showIconByServiceId } from "../../../../../helpers/showIconByServiceId";

const ServiceCard = ({ data }) => {
  const isTablet = useMediaQuery("(max-width:1300px)");
  const calculateDaysLeft = (endDate) => {
    if (!endDate) return 0;

    const end = new Date(endDate);
    const now = new Date();

    // Reset time part to compare only dates
    end.setHours(0, 0, 0, 0);
    now.setHours(0, 0, 0, 0);

    // Calculate difference in days
    const timeDiff = end.getTime() - now.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

    // Return 0 if the date has already passed
    return daysDiff > 0 ? daysDiff : 0;
  };

  const daysLeft = calculateDaysLeft(data?.end_date);
  return (
    <div className="service">
      <div className="main-contain">
        <div className="service-title">
          <img src={showIconByServiceId(data?.service_id)} alt="icon" className="icon" />
          <div className="subtitle">{data?.service}</div>
          {!isTablet && (
            <Tooltip title={data?.type || ""} arrow>
              <div className="description">({data?.type})</div>
            </Tooltip>)}
        </div>
        {isTablet && (
          <Tooltip title={data?.type || ""} arrow>
            <div className="description">({data?.type})</div>
          </Tooltip>)}
        <div className="statistic-data">
          <div className="chart">
            <CircularProgressChart percentage={data?.percentage || 0} />
          </div>
          <div className="days-left">
            <div className="number">{daysLeft}</div>
            <div className="name">Days Left</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
